import { Image, ImageProps } from 'expo-image';
import { Link } from 'expo-router';
import { Pressable, StyleSheet } from 'react-native';

import { useClickLogs } from '@fhs-legacy/frontend/src/hooks/use-click-logs';

export type FrenchDipCardProps = Omit<ImageProps, 'children' | 'source'> & {
  pickUpHref: string;
};

export function FrenchDipCard({ pickUpHref, ...imageProps }: FrenchDipCardProps) {
  const { logFrenchDipCardClickEvent } = useClickLogs();
  return (
    <Link href={pickUpHref} asChild>
      <Pressable onPress={logFrenchDipCardClickEvent}>
        <Image
          alt="French Dip. Served with au jus. Made with premium roast beef. Order now"
          source={require('./french-dip-banner.webp')}
          placeholder={{ thumbhash: 'szgKF4b4iGeJdYd9lIiIx3h1eFAXB3kA' }}
          {...imageProps}
          style={[styles.frenchDip, imageProps.style]}
        />
      </Pressable>
    </Link>
  );
}

const styles = StyleSheet.create({
  frenchDip: {
    aspectRatio: 800 / 811,
  },
});
